// apis
import { BaseApiResponse, CommonQueryOptions, ResultError } from 'modules';
import { ImageAPI } from '../apis/img.api';
import { useCommonQuery } from 'hooks';

export const imageApi = new ImageAPI();

/** 작업자 목록 조회 쿼리 훅 */
export const useGetCi = ({
  options
}: {
  options?: CommonQueryOptions<BaseApiResponse, ResultError, any>;
}) => {
  const queryKeyFactory = () => ['image', 'ci'];

  const queryFn = async () => {
    return await imageApi.getCI();
  };

  return useCommonQuery<null, BaseApiResponse, ResultError, any>({
    data: null,
    options,
    queryKeyFactory,
    queryFn
  });
};
